import {v4 as uuidv4} from 'uuid';

export class BaseVueEntity {

  private _vueId: string;

  constructor() {
    this._vueId = uuidv4();
  }

  public reload(): void {
    this._vueId = uuidv4();
  }


  get vueId(): string {
    return this._vueId;
  }
}
